export { SPEECH_BUBBLE_LIFT, SpeechBubble } from "./SpeechBubble"
export type { SpeechBubbleProps, SpeechBubbleTail } from "./SpeechBubble"
